import { useQuery } from "@tanstack/react-query";
import { conversationsService } from "../api/conversations";

export const conversationKey = (id: string) => ["chat", "conversations", id] as const;

export function useConversation(id: string | undefined) {
  return useQuery({
    queryKey: id ? conversationKey(id) : ["chat", "conversations", "_disabled"],
    queryFn: () => conversationsService.retrieve(id!),
    enabled: Boolean(id),
  });
}
